import React, { useState } from "react";
import PropTypes from "prop-types";
import Autocomplete from '@mui/material/Autocomplete';
import {withStyles} from "@mui/styles"
import TextField from '@mui/material/TextField';
import FormHelperText from '@mui/material/FormHelperText';
import FormControlLabel from '@mui/material/FormControlLabel';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import styles from './style'
// Import Config Constants
import { errorsConstants } from "../../config/constants";
import { CheckBox } from "../CheckBox";

/**
 * Autocomplete Component
 */
function MultiSelectComponent (props) {
  const [open, setOpen] = useState(false);

  /**
   * render html
   */
  const { suggestions, disabled, value, placeholder, className, validators, showErrorMessages, name, error,errorText , classes} = props;

  return (
    <div>
      {suggestions &&
        <React.Fragment>
          <Autocomplete
            classes={{
              option: classes.option,
              paper: classes.customPaper,
              listbox: "multi-select-option-list"
            }}            
            name={name}
            variant={"outlined"}
            multiple
            disableClearable
            autoHighlight
            blurOnSelect={false}
            value={Array.isArray(value) ? value : []}
            disabled={disabled}
            className={className}
            options={suggestions}
            isOptionEqualToValue={(option, value) => option === value}
            onChange={(event, newValue) => {
              props.handleAutoCompolete(name, newValue, event);
            }}
            getOptionLabel={(option) => option}
            renderTags={(value, getTagProps) => {return null;}}
            renderInput={(params) => (
              <TextField
                {...params}
                variant={"outlined"}
                value={Array.isArray(value) ? value : null}
                placeholder={value.length > 0 ? value.filter(v => (v && v!=="Select All")).join(", ") : placeholder}
                name={name}
              />
            )}
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                <FormControlLabel
                  control={<CheckBox style={{ margin: 0, paddingRight: "4px" }} className="autocomplete-checkbox p-0 mr5" color="secondary" checked={selected} />}
                  label={option}
                />
              </li>
            )}
            onOpen={() => {
              setOpen(true);
            }}
            onClose={(e, reason) => {
              if (reason === "blur" || reason === "toggleInput") {
                setOpen(false);
              } else {
                setOpen(true);
              }
            }}
            open={open || false}
          />
          {error && <FormHelperText style={{color:"red"}}>{errorText}</FormHelperText>}
        </React.Fragment>
      }
    </div>
  );
}

// default props
MultiSelectComponent.defaultProps = {
  suggestions: [],
  value: "",
  disabled: false,
  name: "autocomplete",
  placeholder: "",
  validators: [],
  errorMessages: [],
  showErrorMessages: true,
  fieldErrors: [],
  warningFieldName: "",
  margin: "dense",
  className: "",
  suggestionType: "arrayObject",
  defaultValue: null,
  handleAutoCompolete: () => { },
  multiple: true,
  errorText:"",
  error:false
};

// prop types
MultiSelectComponent.propTypes = {
  suggestions: PropTypes.any,
  value: PropTypes.any,
  disabled: PropTypes.bool,
  suggestionType: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  validators: PropTypes.array,
  errorMessages: PropTypes.array,
  showErrorMessages: PropTypes.bool,
  fieldErrors: PropTypes.array,
  margin: PropTypes.string,
  className: PropTypes.string,
  defaultValue: PropTypes.any,
  handleAutoCompolete: PropTypes.func.isRequired,
  multiple: PropTypes.bool,
  errorText:PropTypes.string,
  error:PropTypes.bool,
};

/** Export Component */

export const MultiSelect = withStyles(styles)(MultiSelectComponent);
